import axios from "@/api/axios.js";

export default {
  state: {
    menus: [],
    menu: {},
    categories: [],
  },

  actions: {
    async fetchMenus(context, params) {
      const url = "menus";

      const response = await axios.get(url, { params });

      const menusData = response.data.items;
      context.commit("setMenus", menusData);

      if (menusData.length) {
        context.commit("setMenu", menusData[0]);
      }
    },

    async fetchCategories(context, menu_id) {
      const url = `menus/${menu_id}/categories`;

      const response = await axios.get(url);

      const categoriesData = response.data;
      context.commit("setCategories", categoriesData);
    },
  },

  mutations: {
    setMenus(state, menus) {
      state.menus = menus;
    },

    setMenu(state, menu) {
      state.menu = menu;
    },

    setCategories(state, categories) {
      state.categories = categories;
    },
  },

  getters: {
    getMenus(state) {
      return state.menus;
    },

    getMenu(state) {
      return state.menu;
    },

    getCategories(state) {
      return state.categories;
    },
  },
};
